import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthStateGuard} from './_shared/guards/authState.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: './onboarding/home/home.module#OnboardHomeModule'
  },
  {
    path: 'picker',
    canActivate: [],
    loadChildren: './onboarding/picker/picker.module#OnboardPickerModule'
  },
  {
    path: 'invite-landlord',
    canActivate: [],
    loadChildren: './onboarding/invite-landlord/invite-landlord.module#InviteLandlordModule'
  },
  {
    path: 'invitation-send',
    canActivate: [],
    loadChildren: './onboarding/invitation-landlord-send/invitation-send.module#InvitationSendModule'
  },
  {
    path: 'property',
    canActivate: [],
    loadChildren: './onboarding/property/property.module#OnboardPropertyModule'
  },
  {
    path: 'password',
    canActivate: [],
    loadChildren: './onboarding/create-account/create-account.module#OnboardAccountModule'
  },
  {
    path: 'payment',
    canActivate: [AuthStateGuard],
    loadChildren: './onboarding/payment-information/payment-information.module#PaymentInformationModule'
  },
  {
    path: 'invite-tenants',
    canActivate: [AuthStateGuard],
    loadChildren: './onboarding/invite-tenants/invite-tenants.module#InviteTenantsModule'
  },
  {
    path: 'complete',
    canActivate: [AuthStateGuard],
    loadChildren: './onboarding/confirmation/confirmation.module#ConfirmationModule'
  },
  {
    path: 'login',
    canActivate: [],
    loadChildren: './login/login.module#LoginModule'
  },
  {
    path: 'activate',
    canActivate: [],
    loadChildren: './activate/activate.module#ActivateModule'
  },
  {
    path: 'pricing',
    canActivate: [],
    loadChildren: './pricing/pricing.module#PricingModule'
  },
  {
    path: 'features',
    canActivate: [],
    loadChildren: './features/features.module#FeaturesModule'
  },
  {
    path: 'support',
    canActivate: [],
    loadChildren: './support/support.module#SupportModule'
  },
  {
    path: 'press',
    canActivate: [],
    loadChildren: './press/press.module#PressModule'
  },
  {
    path: 'investors',
    canActivate: [],
    loadChildren: './investors/investors.module#InvestorsModule'
  },
  {
    path: 'about',
    canActivate: [],
    loadChildren: './about/about.module#AboutModule'
  },
  {
    path: 'terms',
    canActivate: [],
    loadChildren: './terms/terms.module#TermsModule'
  },
  {
    path: 'manifesto',
    canActivate: [],
    loadChildren: './manifesto/manifesto.module#ManifestoModule'
  },
  {
    path: 'story',
    canActivate: [],
    loadChildren: './story/story.module#StoryModule'
  },
  {
    path: 'account',
    canActivate: [AuthStateGuard],
    loadChildren: './account/account.module#AccountModule'
  },
  {
    path: '**', redirectTo: '/login', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/app-routing.module.ts